export default {
    data: () => ({
        translations: {
            title: {
                el: "Ρυθμίσεις παράδοσης",
                en: "Delivery Settings",
                it: "Impostazioni di Consegna"
            },
            pickUp: {
                el: "Συλλογή από το κατάστημα",
                en: "Pick Up",
                it: "Raccogliere"
            },
            delivery: {
                el: "Παράδοση",
                en: "Delivery",
                it: "Consegna"
            },
            on: {
                el: "Ενεργό",
                en: "On",
                it: "Sopra"
            },
            off: {
                el: "Ανενεργό",
                en: "Off",
                it: "Off"
            },
            deliveryDistance: {
                el: "",
                en: "Delivery Distance",
                it: ""
            },
            minimumDelivery: {
                el: "",
                en: "Minimum Delivery Amount",
                it: ""
            },
            deliveryFee: {
                el: "Κόστος Παράδοσης",
                en: "Delivery Fee",
                it: "Tassa di consegna"
            },
            includeDiscount: {
                el: "",
                en: "Include Discount",
                it: ""
            },
            tooltip: {
                el: "",
                en: `
                    If this option is enabled the delivery
                    will be allowed only if the total
                    delivery amount is equal or greater than
                    the minimum delivery amount, but after
                    the discount has been applied
                `,
                it: ""
            },
            globalDelivery: {
                el: "",
                en: "Global Delivery",
                it: ""
            }
        }
    })
};
